import React, { Component } from "react";
import { Helmet } from "react-helmet";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import axios from "axios";
import { currencies } from "../../../../../../../static/currencies";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import SearchDropdown from "../../../../../../search/seatchDropdown";
import { data } from "react-router-dom";

export default class CreateOutlet extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedCurrency: currencies[0],
      title: "Create Outlet | Chimera Solutions | Insights",
      form: {
        state: null,
        message: "",
      },
      field: {
        group: {
          data: [],
          value: "",
          message: "",
          state: null,
        },
        brand: {
          data: [],
          value: "",
          message: "",
          state: null,
        },
        name: {
          value: "",
          message: "",
          state: null,
        },
        level: {
          value: [],
          message: "",
          state: null,
        },
        outletExp: {
          value: new Date(
            new Date().getFullYear() + 1,
            new Date().getMonth(),
            new Date().getDate()
          ),
          message: "",
          state: true,
        },
        user: {
          value: [
            {
              id: "",
              name: "",
              state: null,
            },
          ],
          data: [],
          rawData: [],
          message: "",
          state: null,
        },
      },
    };

    this.valueChanged = this.valueChanged.bind(this);

    this.headers = {
      Authorization: this.props.user.data.usrKey,
      "Content-Type": "application/json",
      Accept: "application/json",
    };
  }

  valueChanged = (event) => {
    const element = event.target;

    if (element.getAttribute("data-field")) {
      const field = element.getAttribute("data-field");
      const key = Number(element.getAttribute("data-key"));

      this.setState((prevState) => {
        const value = prevState.field[field].value.map((data, index) => {
          if (index === key) {
            switch (field) {
              case "level":
                return {
                  ...data,
                  status: data.status ? 0 : 1,
                };
              default:
                return data;
            }
          }
          return data;
        });

        return {
          field: {
            ...prevState.field,
            [field]: {
              ...prevState.field[field],
              value: value,
              message: "",
              state: null,
            },
          },
          form: {
            state: false,
          },
        };
      });
    } else {
      this.setState((prevState) => ({
        field: {
          ...prevState.field,
          [element.id]: {
            ...prevState.field[element.id],
            value: element.value,
            message: "",
            state: null,
          },
        },
        form: {
          state: false,
        },
      }));
    }

    this.checkField(element);
  };

  valdidateLevelStates = () => {
    this.setState(
      (prevState) => ({
        field: {
          ...prevState.field,
          level: {
            ...prevState.field.level,
            state: this.state.field.level.value.filter((level) => level.status)
              .length
              ? true
              : false,
          },
        },
      }),
      () => this.validateFields()
    );
  };

  checkField = (data) => {
    clearTimeout(this.time);
    this.time = setTimeout(() => {
      if (data.getAttribute("data-field")) {
        const field = data.getAttribute("data-field");

        switch (field) {
          case "level":
            let state = true;
            let message = "";

            const checkLevels = this.state.field.level.value.filter(
              (level) => level.status
            ).length;

            if (!checkLevels) {
              state = false;
              message = "please select a user level";
            }

            this.setState(
              (prevState) => {
                return {
                  field: {
                    ...prevState.field,
                    [field]: {
                      ...prevState.field[field],
                      message: message,
                      state: state,
                    },
                  },
                };
              },
              () => this.valdidateLevelStates()
            );
            break;
          default:
            break;
        }
      } else {
        switch (data.id) {
          case "brand":
            this.setState((prevState) => ({
              field: {
                ...prevState.field,
                brand: {
                  ...prevState.field.brand,
                  value: [],
                  state: null,
                },
                name: {
                  ...prevState.field.name,
                  value: "",
                  state: null,
                  message: "",
                },
              },
            }));

            if (data.value !== "0") {
              this.setState(
                (prevState) => ({
                  field: {
                    ...prevState.field,
                    brand: {
                      ...prevState.field.brand,
                      value: data.value,
                      state: true,
                    },
                  },
                }),
                () => this.validateFields()
              );
            }
            break;
          case "group":
            this.setState((prevState) => ({
              field: {
                ...prevState.field,
                group: {
                  ...prevState.field.group,
                  value: "",
                  state: null,
                },
                brand: {
                  data: [],
                  value: "",
                  message: "",
                  state: null,
                },
                level: {
                  ...prevState.field.level,
                  value: [],
                  state: null,
                  message: "",
                },
                name: {
                  ...prevState.field.name,
                  value: "",
                  state: null,
                  message: "",
                },
                user: {
                  ...prevState.field.user,
                  value: [
                    {
                      id: "",
                      name: "",
                      state: null,
                    },
                  ],
                  data: [],
                  state: null,
                  message: "",
                },
              },
            }));

            if (data.value !== "0") {
              const group = JSON.parse(data.value);

              this.setState(
                (prevState) => ({
                  field: {
                    ...prevState.field,
                    group: {
                      ...prevState.field.group,
                      value: group.grpKey,
                      state: true,
                    },
                    brand: {
                      ...prevState.field.brand,
                      data: [].concat.apply(
                        [],
                        this.state.field.group.data
                          .filter((data) => data.grpKey === group.grpKey)
                          .map((data) => data.brands)
                      ),
                    },
                    level: {
                      ...prevState.field.level,
                      value: this.state.field.group.data
                        .find((res) => res.grpKey === group.grpKey)
                        .levels.map((level, key) => {
                          let status = 0;

                          if (!key) {
                            status = 1;
                          }

                          return { ...level, status: status };
                        }),
                    },
                    user: {
                      ...prevState.field.user,
                      data: this.state.field.user.rawData.filter(
                        (user) => user.group === group._id
                      ),
                    },
                  },
                }),
                () => this.valdidateLevelStates()
              );
            }
            break;
          case "name":
            if (data.value.length) {
              let state = true;
              let message = "";

              if (data.value.length <= 3) {
                state = false;
                message = "outlet name should be minimum of 4 characters \n";
              }

              if (
                [].concat
                  .apply(
                    [],
                    [].concat.apply(
                      [],
                      this.state.field.group.data
                        .filter(
                          (data) => data.grpKey === this.state.field.group.value
                        )
                        .map((data) =>
                          data.brands
                            .filter(
                              (data) =>
                                data.braKey === this.state.field.brand.value
                            )
                            .map((brand) =>
                              brand.chains.map((chain) => chain.name)
                            )
                        )
                    )
                  )
                  .find((name) => name === data.value)
              ) {
                state = false;
                message = "outlet name exist \n";
              }

              this.setState(
                (prevState) => ({
                  field: {
                    ...prevState.field,
                    [data.id]: {
                      ...prevState.field[data.id],
                      value: data.value,
                      state: state,
                      message: message,
                    },
                  },
                }),
                () => this.validateFields()
              );
            }
            break;
          default:
            break;
        }

        this.validateFields();
      }
    }, 500);
  };

  dateChange = (date) => {
    this.setState((prevState) => ({
      field: {
        ...prevState.field,
        outletExp: {
          ...prevState.field.outletExp,
          value: new Date(date),
          state: true,
        },
      },
    }));
  };

  validateFields = () => {
    this.setState((prevState) => ({
      form: {
        state: false,
      },
    }));

    if (
      this.state.field.brand.state &&
      this.state.field.name.state &&
      this.state.field.group.state &&
      this.state.field.level.state
    ) {
      this.setState((prevState) => ({
        form: {
          state: true,
        },
      }));
    }
  };

  checker(state) {
    const check = {
      icon: "check-circle",
      style: "null",
    };

    switch (state) {
      case true:
        check.icon = "check-circle";
        check.style = "correct";
        break;
      case false:
        check.icon = "times-circle";
        check.style = "wrong";
        break;
      default:
        break;
    }

    return check;
  }

  renderTitle = () => (
    <Helmet>
      <title>{this.state.title}</title>
    </Helmet>
  );

  handleChange = (date) => {
    this.setState((prevState) => ({
      field: {
        ...prevState.field,
        outletExp: date,
      },
    }));
  };

  getUser = async () => {
    try {
      const response = await axios.get(
        this.props.chimeraserv.urlGet + "/user",
        { headers: this.headers }
      );
      this.setState((prevState) => ({
        field: {
          ...prevState.field,
          user: {
            ...prevState.field.user,
            rawData: response.data,
          },
        },
      }));
    } catch (error) {
      // handle error if needed
    }
  };

  getGroup = async () => {
    try {
      const response = await axios.get(
        this.props.chimeraserv.urlGet + "/group",
        { headers: this.headers }
      );
      this.setState((prevState) => ({
        field: {
          ...prevState.field,
          group: {
            ...prevState.field.group,
            data: response.data,
          },
        },
      }));
    } catch (error) {
      // handle error if needed
    }
  };

  componentDidMount = () => {
    this.getGroup();
    this.getUser();
  };

  reset = () =>
    this.setState({
      reset: new Date().getTime(),
    });

  componentDidUpdate = (prevProps, prevState) => {
    if (prevState.reset !== this.state.reset) {
      this.setState((prevState) => ({
        form: {
          state: false,
          message: "",
        },
        field: {
          ...prevState.field,
          group: {
            value: "",
            data: [],
            message: "",
            state: null,
          },
          brand: {
            data: [],
            value: "",
            message: "",
            state: null,
          },
          name: {
            value: "",
            message: "",
            state: null,
          },
          level: {
            data: [],
            value: [],
            message: "",
            state: null,
          },
          user: {
            ...prevState.field.user,
            data: [],
            value: [
              {
                id: "",
                name: "",
                state: null,
              },
            ],
            message: "",
            state: null,
          },
        },
      }));

      this.getGroup();
    }
  };

  add = () => {
    this.setState((prevState) => ({
      field: {
        ...prevState.field,
        user: {
          ...prevState.field.user,
          value: [
            ...prevState.field.user.value,
            {
              id: parseInt(prevState.field.user.value.length + 1),
              name: "",
              state: null,
            },
          ],
          message: "",
          state: null,
        },
      },
    }));
  };

  remove = (key) => {
    const newUsers = [].concat(
      [],
      this.state.field.user.value.filter((vale, index) => key !== index)
    );

    this.setState((prevState) => ({
      field: {
        ...prevState.field,
        user: {
          ...prevState.field.user,
          value: newUsers,
          message: "",
          state: null,
        },
      },
    }));
  };

  submit = async () => {
    this.setState((prevState) => ({
      form: {
        ...prevState.form,
        state: false,
        message: "",
      },
    }));

    try {
      const response = await axios.post(
        `${this.props.chimeraserv.urlPost}/group/create/chain`,
        {
          grpKey: this.state.field.group.value,
          braKey: this.state.field.brand.value,
          name: this.state.field.name.value,
          levels: this.state.field.level.value
            .filter((level) => level.status)
            .map((level) => level.id),
          users: this.state.field.user.value.filter((user) => user.state),
          currency: this.state.selectedCurrency,
          outletExp: new Date(this.state.field.outletExp.value).toDateString(),
        },
        {
          headers: {
            Authorization: this.props.user.data.usrKey,
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        }
      );
      if (response.data && !response.data.__v) {
        //this.reset();
        this.setState((prevState) => ({
          form: {
            ...prevState.form,
            message: "Outlet Created",
          },
        }));
      }
    } catch (error) {
      this.setState((prevState) => ({
        form: {
          ...prevState.form,
          message: JSON.stringify(error),
        },
      }));
    }
  };

  handleCurrencyChange = (e) => {
    this.setState({ selectedCurrency: e.target.value });
  };

  render() {
    return (
      <div className={"custForm"}>
        {this.renderTitle()}

        <div className={["viewTitle"]}>Create New Outlet</div>
        <form onSubmit={() => {}} className={["form"]}>
          <div className={["form-group"]}>
            <label htmlFor="group">
              Group <span>*</span>
            </label>
            <FontAwesomeIcon
              className={[
                "icon",
                this.checker(this.state.field.group.state).style,
              ].join(" ")}
              icon={["fas", this.checker(this.state.field.group.state).icon]}
            />
            <SearchDropdown
              data={this.state.field.group.data}
              name="group"
              value={this.state.field.group.name}
              searchFields={["name", "grpKey"]}
              displayField="name"
              placeholder="Search business group..."
              required={true}
              showIcon={false}
              state={!!this.state.field.group.state}
              onSelect={(group) => {
                const fakeEvent = {
                  target: {
                    id: "group",
                    value: JSON.stringify({
                      name: group.name,
                      grpKey: group.grpKey,
                      _id: group._id,
                    }),
                    getAttribute: (attr) => {
                      // Return null for "data-field" to match select behavior
                      if (attr === "data-field") return null;
                      if (attr === "data-key") return null;
                      return undefined;
                    },
                  },
                };
                this.valueChanged(fakeEvent);
              }}
              allowClear={true}
              noResultsText="No groups found"
            />
            {/* <select
              className="form-control"
              id="group"
              onChange={this.valueChanged}
            >
              <option defaultValue={0} value={0}>
                -- business group of outlet --
              </option>
              {this.state.field.group.data.map((data, key) => (
                <option
                  value={JSON.stringify({
                    name: data.name,
                    grpKey: data.grpKey,
                    _id: data._id,
                  })}
                  key={key}
                >
                  {data.name}
                </option>
              ))}
            </select> */}
          </div>
          <div className={["form-group"]}>
            <label htmlFor="brand">
              Brand <span>*</span>
            </label>
            <FontAwesomeIcon
              className={[
                "icon",
                this.checker(this.state.field.brand.state).style,
              ].join(" ")}
              icon={["fas", this.checker(this.state.field.brand.state).icon]}
            />

            <select
              className="form-control"
              id="brand"
              onChange={this.valueChanged}
            >
              <option defaultValue={0} value={0}>
                -- business brand of outlet --
              </option>
              {this.state.field.brand.data.map((data, key) => {
                return (
                  <option value={data.braKey} key={key}>
                    {data.name}
                  </option>
                );
              })}
            </select>
          </div>
          <div className={["form-group"]}>
            <label>
              Outlet Name <span>*</span>
            </label>
            <FontAwesomeIcon
              className={[
                "icon",
                this.checker(this.state.field.name.state).style,
              ].join(" ")}
              icon={["fas", this.checker(this.state.field.name.state).icon]}
            />
            <div className={["field"]}>
              <input
                type={"text"}
                className={["form-control"]}
                id={"name"}
                placeholder={"enter outlet name"}
                value={this.state.field.name.value}
                onChange={this.valueChanged}
              />
              <span>{this.state.field.name.message}</span>
            </div>
          </div>

          <div className={["form-group"]}>
            <label htmlFor="group">
              Currency <span>*</span>
            </label>
            <FontAwesomeIcon
              className={"icon correct"}
              icon={["fas", "check-circle"]}
            />
            <select
              className="form-control"
              id="group"
              onChange={this.handleCurrencyChange}
              value={this.state.selectedCurrency}
            >
              {currencies.map((item) => (
                <option value={item} key={item}>
                  {item}
                </option>
              ))}
            </select>
          </div>

          <div className={["form-group"]}>
            <label htmlFor="type">
              Levels <span>*</span>
            </label>
            <FontAwesomeIcon
              className={[
                "icon",
                this.checker(this.state.field.level.state).style,
              ].join(" ")}
              icon={["fas", this.checker(this.state.field.level.state).icon]}
            />
            <div className={["custom-control", "custom-checkbox"].join(" ")}>
              {this.state.field.level.value.map((data, key) => {
                return (
                  <div key={key}>
                    <input
                      type={"checkbox"}
                      className={["custom-control-input"]}
                      name="level"
                      id={key}
                      data-key={key}
                      onChange={this.valueChanged}
                      checked={data.status}
                      value={data.id}
                      data-field={"level"}
                    />
                    <label className={"custom-control-label"} htmlFor={key}>
                      {data.name}
                    </label>
                  </div>
                );
              })}
              <div className={["field"]}>
                <span>{this.state.field.level.message}</span>
              </div>
            </div>
          </div>
          <div className={["form-group"]}>
            <label>
              Users <span></span>
            </label>
            <div className={"multipart"}>
              {this.state.field.user.value.map((data, key) => (
                <div className={["field"]} key={key}>
                  <div className={"part"}>
                    <FontAwesomeIcon
                      className={["icon", this.checker(data.state).style].join(
                        " "
                      )}
                      icon={["fas", this.checker(data.state).icon]}
                    />
                    <input
                      type={"text"}
                      className={["form-control", "custField"].join(" ")}
                      id={"name"}
                      placeholder={"enter level name"}
                      value={data.name}
                      data-key={key}
                      onChange={this.valueChanged}
                      data-field={"user"}
                    />
                    {
                      <button
                        type={"button"}
                        onClick={() =>
                          key === 0 ? this.add() : this.remove(key)
                        }
                        className={[
                          "custBtn",
                          key === 0 ? "add" : "remove",
                        ].join(" ")}
                      >
                        <FontAwesomeIcon
                          className={[
                            "icon",
                            this.checker(this.state.field.user.state).style,
                          ].join(" ")}
                          icon={key === 0 ? "plus" : "minus"}
                        />
                      </button>
                    }
                  </div>
                  <span>{data.message}</span>
                </div>
              ))}
            </div>
          </div>

          <div className={["form-group"]}>
            <label>
              Outlet Expiration <span>*</span>
            </label>
            <FontAwesomeIcon
              className={[
                "icon",
                this.checker(this.state.field.outletExp.state).style,
              ].join(" ")}
              icon={[
                "fas",
                this.checker(this.state.field.outletExp.state).icon,
              ]}
            />
            <div className={["date"].join(" ")}>
              <DatePicker
                className={["form-control"]}
                selected={this.state.field.outletExp.value}
                onChange={this.dateChange}
                onSelect={this.dateChange}
                minDate={new Date()}
              />
            </div>
          </div>

          {this.state.form.message ? (
            <div className={["message", "form-group"].join(" ")}>
              <FontAwesomeIcon
                className={["icon", "correct"].join(" ")}
                icon={"check-circle"}
              />
              {this.state.form.message}
            </div>
          ) : (
            <div />
          )}
          <button
            type={"button"}
            className={["btn btn-primary"]}
            disabled={this.state.form.state ? false : true}
            onClick={() => this.submit()}
          >
            Create
          </button>
          <button
            type={"button"}
            onClick={() => this.reset()}
            className={["btn btn-primary", "reset"].join(" ")}
          >
            Reset
          </button>
        </form>
      </div>
    );
  }
}
